import { gql } from '@apollo/client';

export default gql`
  mutation upsertBillingDetails(
    $name: String!
    $address: String!
    $city: String!
    $zipCode: String!
    $taxId: String
    $email: String
  ) {
    upsertBillingDetails(
      input: {
        name: $name
        address: $address
        city: $city
        zipCode: $zipCode
        taxId: $taxId
        email: $email
      }
    ) {
      billingDetails {
        id
        name
        address
        city
        zipCode
        taxId
        email
      }
    }
  }
`;
